export enum SOFT_PHONE_EVENTS {
  SET_BUSY = 'SET_BUSY',
  HANGUP = 'HANGUP',
  SOFT_PHONE_DIALOUT = 'SOFT_PHONE_DIALOUT',
  SOFT_PHONE_LOGIN = 'SOFT_PHONE_LOGIN',
  SWITCH_EXTEN_TYPE = 'SWITCH_EXTEN_TYPE',
}

export const setStyle = (el, style) => {
  for (const key in style) {
    el.style[key] = style[key]
  }
}

export function triggerEvent(action, payload = {}) {
  document.dispatchEvent(
    new CustomEvent('SOFT_PHONE_POST_MESSAGE', {
      detail: {
        payload,
        action,
      },
    })
  )
}

export function triggerPhoneCall(detail = {}) {
  document.dispatchEvent(
    new CustomEvent('SOFT_PHONE_CALL', {
      detail,
    })
  )
}

export let softPhoneGlobal = {
  destroy: () => {},
  hide: () => {},
  callback: {
    disloutSuccess: () => {},
    disloutAbort: () => {},
  },
  iframeEl: null as any,
}
